import { reportDetailsActions } from './reportsDetailsReducer';
import { reportDetailsThunkActions } from './thunk';

export const {
  setWeeklyPayrollReportData,
  setLoadingWeeklyPayrollReport,
  clearWeeklyPayrollReportData,
  setWeeklyPayrollCsvData,
  setPayrollData,
  setLoading,
  setPtoBalances,
  setLoadingPtoBalances,
  setCallbackReportData,
  setLoadingCallbackReport,
  setPtoReportData,
  setLoadingPtoReport,
  clearPtoReportData,
  clearCsvReportData,
  setOvertimeReportData,
  setLoadingOvertimeReport,
  clearOvertimeReportData,
  setPayrollReportData,
  setLoadingPayrollReport,
  clearPayrollReportData,
  setCsvOvertimeReport,
  setLoadCsvOvertimeReport,
  clearCsvOvertimeReportData,
  setOvertimeListMasterReportData,
  setToggleLoadingOvertimeListMasterReportData,
  setMunisReportData,
  setIsLoadingMunisReportData,
  setMunisReportCsvData,
  setIsLoadingMunisCsvData,
  setSwapShiftsData,
  setIsLoadingSwapShifts,
  setAdjustHours,
  setIsLoadingAdjustHours,
  clearAdjustHours,
  setAvailabilityDetail,
  setIsLoadingAvailabilityDetail,
  clearAvailabilityDetail,
  setAvailabilitySummary,
  setIsLoadingAvailabilitySummary,
  clearAvailabilitySummary,
  setMiltonReportData,
  setIsLoadingMiltonReportData,
  setCSVMiltonReportData,
  setCSVIsLoadingMiltonReportData,
  setCharltonReportData,
  setLoadingCharltonReport,
  setCSVCharltonReportData,
  setCSVLoadingCharltonReport,
  setWoburnReportData,
  setIsWoburnReportDataLoading,
  setWoburnCSVReportData,
  setLoadingWoburnCSVReport,
  setWoburnOvertimeReportData,
  setLoadingWoburnOvertimeReport,
  setCSVWoburnOvertimeReportData,
  setLoadingCSVWoburnOvertimeReport,
	setWoburnReassignmentReportData,
	setLoadingWoburnReassignmentReportData,
	setCSVWoburnReassignmentReport,
	setIsLoadingCSVWoburnReassignmentReport,
  setWoburnPTOReportData,
  setLoadingWoburnPTOReport,
  setWoburnPtoCSVReportData,
  setLoadingWoburnPtoCSVReport,
  setWoburnMunisPtoReportData,
  setLoadingWoburnMunisPtoReport,
  setWoburnMunisPtoCSVReportData,
  setLoadingWoburnMunisPtoCSVReport,
  setWoburnMunisOvertimeReportData,
  setLoadingWoburnMunisOvertimeReport,
  setWoburnMunisOvertimeCSVReportData,
  setLoadingWoburnMunisOvertimeCSVReport,

  setAvailableReports,
  setIsAvailableReportsLoading,
  setPtoOptionsList,
  setIsLoadingPtoOptionsList,
} = reportDetailsActions;

export const {
  getWeeklyPayrollReport,
  getWeeklyPayrollReportCsvData,
  getCallbackReport,
  getPtoBalances,
  getPayrollData,
  getPtoReport,
  getEmployeeList,
  getCsvReport,
  getOvertimeReport,
  getPayrollReport,
  getCsvOvertimeReport,
  getOvertimeListMasterReport,
  getMunisReportData,
  getMunisReportCsvData,
  getSwapShiftsReportData,
  getAdjustHoursReportData,
  getAvailabilityDetailReportData,
  getAvailabilitySummaryReportData,
  getMiltonReportData,
  getCSVMiltonReportData,
  getCharltonReportData,
  getCSVCharltonReportData,
  getWoburnReportData,
  getWoburnCSVReportData,
  getWoburnOvertimeReportData,
  getCSVWoburnOvertimeReportData,
	getWoburnReassignmentReportData,
	getCSVWoburnReassignmentReport,
  getWoburnPTOReportData,
  getCSVWoburnPTOReportData,
  getWoburnMunisPtoReport,
  getWoburnMunisPtoCSVReportCsvData,
  getWoburnMunisOvertimeReportData,
  getCSVWoburnMunisOvertimeReportData,
  getAvailableReports,
  getPtoOptionListData,
} = reportDetailsThunkActions;
